import React, { useEffect, memo } from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from '../components/FadeIn';
import { Contact } from '../components/Contact';
export function WeddingsPricing() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-cream text-charcoal min-h-screen" data-id="element-216">
      {/* Hero Section */}
      <section className="relative pt-44 pb-32 bg-charcoal text-white overflow-hidden" data-id="element-217">
        <div className="absolute inset-0 z-0 opacity-40" data-id="element-218">
          <img src="https://code-11.hr/wp-content/uploads/2025/05/2G6A8559-scaled.jpg" alt="Wedding setup" className="w-full h-full object-cover" data-id="element-219" />
          <div className="absolute inset-0 bg-gradient-to-b from-charcoal/80 via-charcoal/60 to-charcoal" data-id="element-220" />
        </div>

        <div className="container mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-221">
          <FadeIn data-id="element-222">
            <h1 className="text-5xl md:text-7xl font-serif mb-6 leading-tight font-normal" data-id="element-223">
              Weddings
            </h1>
            <p className="font-script text-3xl md:text-5xl text-copper mb-12" data-id="element-224">
              Diamond premium booking
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Welcome & About Us */}
      <section className="py-24 md:py-32 bg-cream" data-id="element-225">
        <div className="container mx-auto px-6 md:px-12" data-id="element-226">
          <div className="max-w-4xl mx-auto text-center space-y-16" data-id="element-227">
            <FadeIn data-id="element-228">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-229">
                Welcome
              </span>
              <p className="font-serif text-xl md:text-2xl leading-relaxed text-charcoal/80" data-id="element-230">
                At Code 11 in Hvar, we believe a wedding is more than a
                celebration – it is a moment where love and place become one.
                Our philosophy is simple: every couple carries their own unique
                code, a story written in emotions, memories and dreams. Here,
                overlooking the Adriatic and surrounded by timeless
                Mediterranean beauty, we create weddings that go beyond the
                ordinary. With exquisite cuisine, curated details and a setting
                that breathes elegance, your day becomes a true reflection of
                who you are.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-231">
              <div className="w-16 h-[1px] bg-copper mx-auto my-16" data-id="element-232"></div>
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-233">
                About Us
              </span>
              <div className="space-y-8 font-sans text-charcoal/70 leading-relaxed font-light" data-id="element-234">
                <p data-id="element-235">
                  At Code 11, every wedding is more than a celebration — it is
                  the beginning of a love story written in moments, emotions and
                  memories that last a lifetime.
                </p>
                <p data-id="element-236">
                  With Diamond Premium Booking, we go beyond while offering an
                  extraordinary venue. We listen to your dreams, feel your
                  vision and transform them into a reality that is uniquely
                  yours. From delicate décor and inspired planning, to music
                  that touches the soul and details that speak of your love, we
                  create not just a wedding — but an unforgettable journey.
                </p>
                <p data-id="element-237">
                  Your story deserves to be celebrated in a place where every
                  corner whispers romance and every detail is designed with you
                  in mind. At Code 11, your wedding becomes a masterpiece of
                  love, created just for you.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-24 md:py-32 bg-charcoal text-white" data-id="element-238">
        <div className="container mx-auto px-6 md:px-12" data-id="element-239">
          <FadeIn data-id="element-240">
            <div className="text-center mb-20" data-id="element-241">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-242">
                Our Services
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-normal" data-id="element-243">
                Crafting Your Perfect Day
              </h2>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20" data-id="element-244">
            <FadeIn delay={0.1} data-id="element-245">
              <h3 className="text-xl font-serif text-copper mb-4" data-id="element-246">
                Wedding Planner & Décor
              </h3>
              <p className="font-sans text-white/70 font-light leading-relaxed" data-id="element-247">
                Décor is the soul of your wedding atmosphere. From timeless
                elegance to modern romance, our design team transforms spaces
                into breathtaking settings that reflect your unique story. Every
                flower, every candle, every detail is curated to create harmony,
                beauty, and emotion — so that your wedding feels like it was
                made only for you.
              </p>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-248">
              <h3 className="text-xl font-serif text-copper mb-4" data-id="element-249">
                Flower Decoration
              </h3>
              <p className="font-sans text-white/70 font-light leading-relaxed" data-id="element-250">
                Bespoke floral arrangements designed to complement your vision
                and elevate the venue's natural Mediterranean beauty.
              </p>
            </FadeIn>
            <FadeIn delay={0.3} data-id="element-251">
              <h3 className="text-xl font-serif text-copper mb-4" data-id="element-252">Music</h3>
              <p className="font-sans text-white/70 font-light leading-relaxed" data-id="element-253">
                The soundtrack of your wedding sets the rhythm of the
                celebration. From romantic violins and string quartets to lively
                bands and DJs, we offer a diverse selection of artists who
                elevate every moment. Whether it is the gentle melody during
                your ceremony or the vibrant energy of the dance floor, our
                entertainment transforms your wedding into an unforgettable
                experience.
              </p>
            </FadeIn>
            <FadeIn delay={0.4} data-id="element-254">
              <h3 className="text-xl font-serif text-copper mb-4" data-id="element-255">
                Photographer
              </h3>
              <p className="font-sans text-white/70 font-light leading-relaxed" data-id="element-256">
                Your wedding is a collection of moments that deserve to be
                remembered forever. Our photographers and videographers capture
                not only the images but also the emotions, creating timeless
                memories that you will relive for years to come. With a blend of
                artistry and discretion, we ensure that every smile, every
                glance and every detail is preserved with elegance.
              </p>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="py-24 md:py-32 bg-cream" data-id="element-257">
        <div className="container mx-auto px-6 md:px-12" data-id="element-258">
          <FadeIn data-id="element-259">
            <div className="text-center mb-16" data-id="element-260">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-261">
                Our Team
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-normal" data-id="element-262">
                The Visionaries
              </h2>
            </div>
          </FadeIn>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 max-w-4xl mx-auto" data-id="element-263">
            {[{
            name: 'Luka i Vito Kožul',
            role: "Code11's owners",
            image: 'https://code-11.hr/wp-content/uploads/elementor/thumbs/Screenshot-2026-01-29-at-12.36.28-rid84og68y6juqxr9tfx51xl1xki8253a7d9zjxy2s.png'
          }, {
            name: 'Irena Viličić',
            role: 'Wedding planner',
            image: 'https://code-11.hr/wp-content/uploads/elementor/thumbs/Screenshot-2026-01-29-at-12.36.37-rid84wwpygi4r8lgwf3k9hsqeeet5c2obd8nb1lel0.png'
          }, {
            name: 'Snješka Kožul',
            role: 'Decorator',
            image: 'https://code-11.hr/wp-content/uploads/elementor/thumbs/Screenshot-2026-01-29-at-12.36.43-rid852jr3gpuowd9zhjbogdhypn0fip2c55k6pd1je.png'
          }, {
            name: 'Jan Humski',
            role: 'Photographer',
            image: 'https://code-11.hr/wp-content/uploads/elementor/thumbs/Screenshot-2026-01-29-at-12.36.50-rid8586s8gxkmk532jz33ey9j0v7ppbgcx2h2d4oi2.png'
          }].map((member, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-264">
                <div className="group flex flex-col items-center text-center" data-id="element-265">
                  <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden ring-1 ring-charcoal/10 group-hover:ring-copper/40 transition-all mb-5" data-id="element-266">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-267" />
                  </div>
                  <h4 className="font-serif text-base mb-1" data-id="element-268">{member.name}</h4>
                  <p className="font-sans text-[10px] uppercase tracking-widest text-copper" data-id="element-269">
                    {member.role}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* Restaurant Rental */}
      <section className="py-24 md:py-32 bg-charcoal text-white" data-id="element-270">
        <div className="container mx-auto px-6 md:px-12" data-id="element-271">
          <FadeIn data-id="element-272">
            <div className="text-center mb-16" data-id="element-273">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-274">
                Venue
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-normal" data-id="element-275">
                Restaurant Rental
              </h2>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-276">
            {[{
            opt: 'Option A',
            dates: 'From the 1st of May to May 31st',
            price: '€3,500'
          }, {
            opt: 'Option B',
            dates: 'From the 1st of June to August 31st',
            price: '€5,500'
          }, {
            opt: 'Option C',
            dates: 'From the 1st of September to September 30th',
            price: '€3,500'
          }].map((rental, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-277">
                <div className="border border-white/10 p-10 text-center h-full flex flex-col justify-center relative overflow-hidden group hover:bg-white/5 transition-colors" data-id="element-278">
                  <div className="absolute top-0 left-0 w-full h-1 bg-copper transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-279"></div>
                  <span className="font-sans text-xs uppercase tracking-[0.2em] text-white/50 mb-4 block" data-id="element-280">
                    {rental.opt}
                  </span>
                  <p className="font-sans font-light text-white/80 mb-6" data-id="element-281">
                    {rental.dates}
                  </p>
                  <p className="font-serif text-3xl text-copper" data-id="element-282">
                    {rental.price}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* Welcome Drinks & Canapes */}
      <section className="py-24 md:py-32 bg-cream" data-id="element-283">
        <div className="container mx-auto px-6 md:px-12" data-id="element-284">
          <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-285">
            <FadeIn data-id="element-286">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-287">
                Arrival
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-normal mb-8" data-id="element-288">
                Welcome Drinks
              </h2>
              <p className="font-sans text-charcoal/70 font-light mb-8" data-id="element-289">
                Upon arrival at Code 11, we'll welcome you with a selection of
                two available options:
              </p>

              <ul className="space-y-6 font-sans font-light text-charcoal/80 mb-12" data-id="element-290">
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-291">
                  <span data-id="element-292">Dobra Berba Piena (prosecco)</span>
                  <span className="font-medium" data-id="element-293">6€ per glass</span>
                </li>
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-294">
                  <span data-id="element-295">Vueve Clicquot (champagne)</span>
                  <span className="font-medium" data-id="element-296">20€ per glass</span>
                </li>
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-297">
                  <span data-id="element-298">Aperol Or Limoncello Spritz</span>
                  <span className="font-medium" data-id="element-299">15€ per glass</span>
                </li>
              </ul>

              <div className="bg-white p-8 border border-charcoal/5" data-id="element-300">
                <h4 className="font-serif text-xl mb-4" data-id="element-301">from 5 – 7 PM</h4>
                <p className="text-copper font-medium mb-4" data-id="element-302">25€/h per person</p>
                <p className="font-sans text-sm font-light text-charcoal/70 leading-relaxed" data-id="element-303">
                  Water (still or sparkling) • Beer (local draft or bottled) •
                  Dobra Berba Piena (prosecco) • Aperol/Limoncello Spritz •
                  Fresh juices (mint lemonade, orange juice)
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-304">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-305">
                Bites
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-normal mb-8" data-id="element-306">
                Canapés
              </h2>
              <p className="font-sans text-charcoal/70 font-light mb-8" data-id="element-307">
                You can also choose several canape options:
              </p>

              <ul className="space-y-6 font-sans font-light text-charcoal/80" data-id="element-308">
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-309">
                  <span data-id="element-310">Classic Mediterranean Bruschetta</span>
                  <span className="font-medium" data-id="element-311">4€ per piece</span>
                </li>
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-312">
                  <span data-id="element-313">Prosciutto Melon bites</span>
                  <span className="font-medium" data-id="element-314">4€ per piece</span>
                </li>
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-315">
                  <span data-id="element-316">Smoked Salmon bites</span>
                  <span className="font-medium" data-id="element-317">4€ per piece</span>
                </li>
                <li className="flex justify-between border-b border-charcoal/10 pb-2" data-id="element-318">
                  <span data-id="element-319">Prosciutto, Cheese & Olives canape</span>
                  <span className="font-medium" data-id="element-320">4€ per piece</span>
                </li>
              </ul>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Drink Menus */}
      <section className="py-24 md:py-32 bg-charcoal text-white" data-id="element-321">
        <div className="container mx-auto px-6 md:px-12" data-id="element-322">
          <FadeIn data-id="element-323">
            <div className="text-center mb-16" data-id="element-324">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-325">
                Beverages
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-normal" data-id="element-326">
                Drink Menu Options
              </h2>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-327">
            <FadeIn delay={0.1} data-id="element-328">
              <div className="border border-white/10 p-10 h-full flex flex-col bg-white/5" data-id="element-329">
                <h3 className="font-serif text-2xl mb-2 text-copper" data-id="element-330">
                  Classic Code Package
                </h3>
                <p className="font-sans text-lg mb-8" data-id="element-331">80€ per person</p>
                <p className="font-sans text-xs uppercase tracking-[0.2em] text-white/50 mb-4" data-id="element-332">
                  Includes:
                </p>
                <ul className="font-sans font-light text-sm text-white/70 space-y-3 flex-grow" data-id="element-333">
                  <li data-id="element-334">- A glass of prosecco Dobra Berba Piena</li>
                  <li data-id="element-335">
                    - Pavino Pinot Grigio (white wine, from a local biodynamic
                    producer from Hvar)
                  </li>
                  <li data-id="element-336">
                    - Pavino Merlot Futura (red wine, from a local biodynamic
                    producer from Hvar)
                  </li>
                  <li data-id="element-337">- Matijević Rose</li>
                  <li data-id="element-338">- Draft Beer, Heineken 0,33l</li>
                  <li data-id="element-339">- Natural Juices</li>
                  <li data-id="element-340">- Still & Sparkling Water</li>
                </ul>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-341">
              <div className="border border-copper p-10 h-full flex flex-col bg-copper/5 relative" data-id="element-342">
                <div className="absolute top-0 right-0 bg-copper text-charcoal text-[10px] font-bold uppercase tracking-widest px-3 py-1" data-id="element-343">
                  Popular
                </div>
                <h3 className="font-serif text-2xl mb-2 text-copper" data-id="element-344">
                  Signature Code Package
                </h3>
                <p className="font-sans text-lg mb-8" data-id="element-345">130€ per person</p>
                <p className="font-sans text-xs uppercase tracking-[0.2em] text-white/50 mb-4" data-id="element-346">
                  Includes:
                </p>
                <ul className="font-sans font-light text-sm text-white/70 space-y-3 flex-grow" data-id="element-347">
                  <li data-id="element-348">- A glass of Vueve Clicquot champagne</li>
                  <li data-id="element-349">- Zlatan Otok, Pošip (premium white wine)</li>
                  <li data-id="element-350">- Matijević Plavac Mali (premium red wine)</li>
                  <li data-id="element-351">- Chateau Minuty Rose (premium rose)</li>
                  <li data-id="element-352">- Gray Goose Vodka, Old Pilot's Gin</li>
                  <li data-id="element-353">- Glenmorange 12yo Whiskey</li>
                  <li data-id="element-354">- Still & Sparkling Water, Natural Juices</li>
                  <li data-id="element-355">- Draft Beer, Corona, Heineken</li>
                </ul>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-356">
              <div className="border border-white/10 p-10 h-full flex flex-col bg-white/5" data-id="element-357">
                <h3 className="font-serif text-2xl mb-2 text-copper" data-id="element-358">
                  Liberty Code Package
                </h3>
                <p className="font-sans text-lg mb-8" data-id="element-359">Custom Pricing</p>
                <div className="flex-grow flex items-center justify-center text-center" data-id="element-360">
                  <p className="font-sans font-light text-white/70 italic" data-id="element-361">
                    An open bar option that is tailor made to your wishes.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Food Menus */}
      <section className="py-24 md:py-32 bg-cream" data-id="element-362">
        <div className="container mx-auto px-6 md:px-12" data-id="element-363">
          <FadeIn data-id="element-364">
            <div className="text-center mb-20" data-id="element-365">
              <span className="text-copper font-sans uppercase tracking-[0.2em] text-xs mb-6 block" data-id="element-366">
                Gastronomy
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-normal" data-id="element-367">
                Food Menus
              </h2>
            </div>
          </FadeIn>

          <div className="space-y-24 max-w-5xl mx-auto" data-id="element-368">
            {/* Code Red */}
            <FadeIn data-id="element-369">
              <div className="bg-white p-10 md:p-16 border border-charcoal/5 shadow-sm" data-id="element-370">
                <div className="text-center mb-12" data-id="element-371">
                  <h3 className="font-serif text-3xl text-charcoal mb-2" data-id="element-372">
                    Code Red Menu
                  </h3>
                  <p className="font-sans text-copper tracking-widest uppercase text-sm" data-id="element-373">
                    90€ per person
                  </p>
                </div>

                <div className="space-y-10" data-id="element-374">
                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-375">
                    <div className="md:w-1/4" data-id="element-376">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-377">
                        Starter
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-378">
                      <h4 className="font-serif text-xl mb-2" data-id="element-379">
                        Prosciutto & Mozzarella Arancini
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-380">
                        Artisan rice balls with prosciutto and mozzarella,
                        coated in golden panko crumbs and served with our
                        house-made smoked paprika sauce.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-381">
                    <div className="md:w-1/4" data-id="element-382">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-383">
                        Main 1
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-384">
                      <h4 className="font-serif text-xl mb-2" data-id="element-385">
                        Beef Carpaccio
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-386">
                        Prime cuts of beef, finely sliced and delicately
                        seasoned, paired with fresh arugula, shaved Parmesan,
                        and a drizzle of extra virgin olive oil, finished with
                        citrus zest and sea salt flakes.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-387">
                    <div className="md:w-1/4" data-id="element-388">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-389">
                        Main 2
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-390">
                      <h4 className="font-serif text-xl mb-2" data-id="element-391">
                        French Rack with Silky Pistachio Purée
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-392">
                        Tender lamb chops, seared and served with a silky
                        pistachio-infused purée seasoned with Mediterranean
                        aromatic herbs.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-393">
                    <div className="md:w-1/4" data-id="element-394">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-395">
                        Dessert
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-396">
                      <h4 className="font-serif text-xl mb-2" data-id="element-397">
                        "Mamma's Secret" Tiramisu
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-398">
                        A signature family recipe refined into a fine dining
                        indulgence – velvety mascarpone, espresso-soaked
                        biscuits, and a delicate cocoa veil.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>

            {/* Code White */}
            <FadeIn data-id="element-399">
              <div className="bg-white p-10 md:p-16 border border-charcoal/5 shadow-sm" data-id="element-400">
                <div className="text-center mb-12" data-id="element-401">
                  <h3 className="font-serif text-3xl text-charcoal mb-2" data-id="element-402">
                    Code White Menu
                  </h3>
                  <p className="font-sans text-copper tracking-widest uppercase text-sm" data-id="element-403">
                    100€ per person
                  </p>
                </div>

                <div className="space-y-10" data-id="element-404">
                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-405">
                    <div className="md:w-1/4" data-id="element-406">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-407">
                        Starter
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-408">
                      <h4 className="font-serif text-xl mb-2" data-id="element-409">
                        Lobster Bisque & Arancini
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-410">
                        A classic creamy bisque made with butter, cream, white
                        wine, cherry tomatoes & lobster meat, seasoned with
                        locally grown herbs. Prosciutto & Mozzarella Arancini
                        coated in golden panko crumbs.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-411">
                    <div className="md:w-1/4" data-id="element-412">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-413">
                        Main 1
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-414">
                      <h4 className="font-serif text-xl mb-2" data-id="element-415">
                        Signature Truffle Gnocchi
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-416">
                        Handcrafted pillows of gnocchi, elevated with rich
                        truffle flavors, a touch of butter, and aged Parmesan.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-417">
                    <div className="md:w-1/4" data-id="element-418">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-419">
                        Main 2
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-420">
                      <h4 className="font-serif text-xl mb-2" data-id="element-421">
                        Gourmet Chef's Duck
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-422">
                        A true chef's masterpiece – succulent duck paired with
                        golden, crispy potatoes and a vibrant green sauce,
                        harmoniously balanced to perfection.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-423">
                    <div className="md:w-1/4" data-id="element-424">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-425">
                        Dessert
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-426">
                      <h4 className="font-serif text-xl mb-2" data-id="element-427">Golden Zest</h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-428">
                        A refined citrus creation, with silky lemon curd and a
                        toasted meringue crown.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>

            {/* Code Blue */}
            <FadeIn data-id="element-429">
              <div className="bg-white p-10 md:p-16 border border-charcoal/5 shadow-sm" data-id="element-430">
                <div className="text-center mb-12" data-id="element-431">
                  <h3 className="font-serif text-3xl text-charcoal mb-2" data-id="element-432">
                    Code Blue Menu
                  </h3>
                  <p className="font-sans text-copper tracking-widest uppercase text-sm" data-id="element-433">
                    80€ per person
                  </p>
                </div>

                <div className="space-y-10" data-id="element-434">
                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-435">
                    <div className="md:w-1/4" data-id="element-436">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-437">
                        Starter
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-438">
                      <h4 className="font-serif text-xl mb-2" data-id="element-439">
                        Mediterranean Octopus Salad
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-440">
                        Poached octopus with fresh herbs, colorful vegetables,
                        and a light lemon-olive dressing – a refreshing taste of
                        the sea.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-441">
                    <div className="md:w-1/4" data-id="element-442">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-443">
                        Main 1
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-444">
                      <h4 className="font-serif text-xl mb-2" data-id="element-445">
                        Dark Knight Risotto
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-446">
                        Traditional cuttlefish risotto made with our house black
                        sauce served in a Parmesan basket.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8 border-b border-charcoal/5 pb-8" data-id="element-447">
                    <div className="md:w-1/4" data-id="element-448">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-449">
                        Main 2
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-450">
                      <h4 className="font-serif text-xl mb-2" data-id="element-451">
                        White Fish à la Chef
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-452">
                        Flaky white fillet infused with rosemary aroma, served
                        with golden potatoes and a light herb sauce – elegance
                        on a plate.
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-453">
                    <div className="md:w-1/4" data-id="element-454">
                      <span className="font-sans text-xs uppercase tracking-[0.2em] text-charcoal/40" data-id="element-455">
                        Dessert
                      </span>
                    </div>
                    <div className="md:w-3/4" data-id="element-456">
                      <h4 className="font-serif text-xl mb-2" data-id="element-457">
                        Snowflake Chocolate Cake
                      </h4>
                      <p className="font-sans font-light text-charcoal/70" data-id="element-458">
                        A decadent family recipe, elevated with gourmet finesse
                        – layers of rich chocolate cake, enveloped in silky
                        ganache and finished with white chocolate accents.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      <Contact data-id="element-459" />
    </main>;
}